var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.clientWidth >= 992 ? 'container-list-pc' : 'container-list']},[_c('div',{class:[_vm.clientWidth >= 992 ? 'title-text-pc' : 'title-text']},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.list),function(item){return _c('div',{class:[_vm.clientWidth >= 992 ? 'detail-item-pc' : 'detail-item'],style:({
        backgroundImage: 'url(' + _vm.DetailBg + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
    })},[_c('div',{class:[_vm.clientWidth >= 992 ? 'detail-text-pc' : 'detail-text']},[_vm._v(_vm._s(item.name))]),_c('div',{class:[_vm.clientWidth >= 992 ? 'down-text-pc' : 'down-text']},[_vm._v("下载")])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }